import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

import { Card } from "@/components/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";

import { EventDetailsSkeleton } from "./event-details-skeleton";

function BadgeSkeleton() {
  return (
    <div className="relative h-4 w-[76px]">
      <div className="absolute inset-0 animate-pulse bg-gradient-to-r from-transparent via-[#6941C6] to-transparent" />
    </div>
  );
}

function DescriptionCardSkeleton() {
  return (
    <Card>
      <Card.Content>
        <div className="flex flex-col gap-4">
          <BadgeSkeleton />
          <div className="h-4 w-3/4 animate-pulse rounded-md bg-gray-200" />
          <div className="h-4 w-3/4 animate-pulse rounded-md bg-gray-200" />
        </div>
      </Card.Content>
    </Card>
  );
}

function RegisterForEventCardSkeleton() {
  return (
    <Card className="relative w-full self-start overflow-hidden">
      <Card.Content className="flex flex-col gap-16">
        <div className="flex flex-col gap-4">
          <div className="relative h-6 w-full animate-pulse rounded-md bg-foreground" />
          <div className="relative h-4 w-full animate-pulse rounded-md bg-muted-foreground" />
          <div className="relative h-4 w-full animate-pulse rounded-md bg-muted-foreground" />
        </div>
        <div className="flex flex-col gap-2">
          <div className="relative h-8 w-full animate-pulse rounded-md bg-primary" />
          <div className="relative h-8 w-full animate-pulse rounded-md bg-muted-foreground" />
        </div>
      </Card.Content>
      <div className="absolute left-0 top-[calc(50%+10px)] w-full -translate-y-1/2">
        <div className="absolute left-[-14px] top-[-14px] h-7 w-7 rounded-full bg-card" />
        <div className="absolute right-[-14px] top-[-14px] h-7 w-7 rounded-full bg-card" />
        <div className="border-[length:1px_6px] border-t border-dashed" />
      </div>
    </Card>
  );
}

function AttendeesCardSkeleton() {
  return (
    <Card className="relative w-full self-start overflow-hidden">
      <Card.Content className="flex flex-col gap-16">
        <div className="flex flex-col gap-4">
          <div className="relative h-6 w-full">
            <div className="absolute inset-0 animate-pulse rounded-md bg-gradient-to-r from-transparent via-[#6941C6] to-transparent" />
          </div>
          <div className="relative h-4 w-full animate-pulse rounded-md bg-muted-foreground" />
        </div>
      </Card.Content>
    </Card>
  );
}

export function EventSkeleton() {
  return (
    <div className="flex flex-col gap-12">
      <Button variant="ghost" asChild className="self-start">
        <Link to="/events/discover">
          <ArrowLeft className="mr-2 size-4" aria-hidden="true" />
          Return to Events
        </Link>
      </Button>
      <div className="flex flex-col gap-6">
        <div className="relative h-8 w-full max-w-[300px]">
          <div className="absolute inset-0 animate-pulse bg-gradient-to-r from-transparent via-[#111827] to-transparent" />
        </div>
        <EventDetailsSkeleton />
      </div>
      <div className="flex flex-col gap-6 lg:flex-row">
        <div className="flex w-full flex-col gap-6">
          <Card>
            <AspectRatio ratio={7 / 4}>
              <div className="absolute inset-0 animate-pulse bg-gradient-to-r from-transparent via-[#111827] to-transparent" />
            </AspectRatio>
          </Card>
          <DescriptionCardSkeleton />
        </div>
        <div className="flex w-full flex-col gap-6 lg:max-w-[410px]">
          <RegisterForEventCardSkeleton />
          <AttendeesCardSkeleton />
        </div>
      </div>
    </div>
  );
}
